<wbo-report-page #reportPage (onLoadedSavedReport)="loadedSavedReport()" [formGroup]="reportPage.formGroup" [myReportPostFix]="myReportPostFix" [title]="reportConfig?.formattedName">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'"
                     *ngIf="reportConfig?.properties.showDate && !reportConfig?.properties.showSingleDate">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.formation.singleDateSelection'"
                     *ngIf="reportConfig?.properties.showSingleDate">
                <wbo-single-date-report-criteria></wbo-single-date-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'" *ngIf="reportConfig?.properties.showOptions">
                <fui-rows>
                    <fui-row *ngIf="reportConfig?.properties.showMovementType">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-stock-movement-multi-select-search-control [formControlName]="'stockMovement'"
                                                                                [(ngModel)]="model.data.stockMovement">
                                </wbo-stock-movement-multi-select-search-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column *ngIf="reportConfig?.properties.showPurchaseOrderRecivedOption">
                                <wbo-checkbox-edit-control [formControlName]="'includeReceivedOrders'"
                                                           [(ngModel)]="model.data.includeReceivedOrders">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-column *ngIf="reportConfig?.properties.showPurchaseOrderRecivableOption">
                                <wbo-checkbox-edit-control [formControlName]="'includeReceivableOrders'"
                                                           [(ngModel)]="model.data.includeReceivableOrders">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-column *ngIf="reportConfig?.properties.showPurchaseOrderPendingOption">
                                <wbo-checkbox-edit-control [formControlName]="'includePendingPurchaseOrders'"
                                                           [(ngModel)]="model.data.includePendingPurchaseOrders">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-column *ngIf="reportConfig?.properties.showPendingReceiveOrderOption">
                                <wbo-checkbox-edit-control [formControlName]="'includePendingReceiveOrders'"
                                                           [(ngModel)]="model.data.includePendingReceiveOrders">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-column *ngIf="reportConfig?.properties.showPendingStockTransferOption">
                                <wbo-checkbox-edit-control [formControlName]="'includePendingStockTransfers'"
                                                           [(ngModel)]="model.data.includePendingStockTransfers">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                    <fui-row *ngIf="reportConfig?.properties.showEmployeeStatusOption">
                        <fui-two-columns>
                            <fui-column [label]="'wbo.custom-report.edit.field-set.employeeStatus'">
                                <fui-rows>
                                    <fui-row>
                                        <fui-two-columns>
                                            <fui-column>
                                                <wbo-checkbox-edit-control
                                                    [formControlName]="'includeEmployeeStatusFullTime'"
                                                    [(ngModel)]="model.data.includeEmployeeStatusFullTime">
                                                </wbo-checkbox-edit-control>
                                            </fui-column>
                                            <fui-column>
                                                <wbo-checkbox-edit-control
                                                    [formControlName]="'includeEmployeeStatusPermanentPartTime'"
                                                    [(ngModel)]="model.data.includeEmployeeStatusPermanentPartTime">
                                                </wbo-checkbox-edit-control>
                                            </fui-column>
                                        </fui-two-columns>
                                    </fui-row>
                                    <fui-row>
                                        <fui-two-columns>
                                            <fui-column>
                                                <wbo-checkbox-edit-control
                                                    [formControlName]="'includeEmployeeStatusPartTime'"
                                                    [(ngModel)]="model.data.includeEmployeeStatusPartTime">
                                                </wbo-checkbox-edit-control>
                                            </fui-column>
                                            <fui-column>
                                                <wbo-checkbox-edit-control [formControlName]="'includeEmployeeStatusCasual'"
                                                                           [(ngModel)]="model.data.includeEmployeeStatusCasual">
                                                </wbo-checkbox-edit-control>
                                            </fui-column>
                                        </fui-two-columns>
                                    </fui-row>
                                    <fui-row>
                                        <fui-two-columns>
                                            <fui-column>
                                                <wbo-checkbox-edit-control
                                                    [formControlName]="'includeEmployeeStatusUnemployed'"
                                                    [(ngModel)]="model.data.includeEmployeeStatusUnemployed">
                                                </wbo-checkbox-edit-control>
                                            </fui-column>
                                        </fui-two-columns>
                                    </fui-row>
                                </fui-rows>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="(reportConfig?.properties.showOutletGroupList || reportConfig?.properties.showLocationOutlet) && !reportConfig?.properties.showLocationList">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-location-single-select-edit-control [(ngModel)]="model.data.outletGroupId"
                                                                         [allowClearSelectionOption]="false"
                                                                         [formControlName]="'outletGroupId'">
                                </wbo-location-single-select-edit-control>
                            </fui-column>
                            <fui-column *ngIf="reportConfig?.properties.showLocationOutlet">
                                <wbo-outlet-multi-select-edit-control [formControlName]="'outlets'"
                                                                      [(ngModel)]="model.data.outlets"
                                                                      [multiObjectValueType]="true"
                                                                      [outletGroupId]="model.data.outletGroupId">
                                </wbo-outlet-multi-select-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row *ngIf="reportConfig?.properties.showBestSellerOptions">
                        <wbo-best-worst-sellers-report-criteria></wbo-best-worst-sellers-report-criteria>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row *ngIf="reportConfig?.properties.showEmployeeList">
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
            <fui-row *ngIf="reportConfig?.properties.showSupplierList">
                <wbo-supplier-report-selection></wbo-supplier-report-selection>
            </fui-row>
            <fui-row *ngIf="reportConfig?.properties.showInventoryList">
                <wbo-inventory-report-selection></wbo-inventory-report-selection>
            </fui-row>
            <fui-row *ngIf="reportConfig?.properties.showAccessRoleOption">
                <wbo-access-role-report-selection></wbo-access-role-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
